type CustomerAnalytics = {
  uid: string;
  visitorExistingCustomer: string;
  visitorLoginState: string;
};

export class AnalyticsService {
  constructor() {
    window.dataLayer = window.dataLayer || [];
  }

  setUniversalAnalytics(customerAnalyticsData: CustomerAnalytics) {
    window.dataLayer.push(customerAnalyticsData);
  }

  setAnalytics(customer: { analytics: CustomerAnalytics }) {
    if (customer) {
      if (customer.analytics) this.setUniversalAnalytics(customer.analytics);
    }
  }
}
